import { combineReducers } from 'redux'
import snippets from './snippets'
//import todos from './todos'

export default combineReducers({
    snippets
})
